<template>
  <Container
    title="充值统计"
    :returnBtn="false"
  >
    <div style="padding: 20px;">
      <!-- 时间选择器 -->
      <el-form :inline="true" class="demo-form-inline" style="margin-bottom: 20px;">
        <el-form-item label="选择日期">
          <el-date-picker
            v-model="selectedDate"
            type="date"
            placeholder="选择日期"
            format="YYYY年MM月DD日"
            value-format="YYYY-MM-DD"
            :picker-options="{
              shortcuts: [
                {
                  text: '今天',
                  value: new Date()
                },
                {
                  text: '昨天',
                  value: () => {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    return date;
                  }
                },
                {
                  text: '最近7天',
                  value: () => {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    return date;
                  }
                }
              ]
            }"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchData">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportExcel">导出Excel</el-button>
        </el-form-item>
      </el-form>

      <!-- 统计概览 -->
      <div class="stats-overview">
        <el-card shadow="hover" class="stats-card">
          <template #header>
            <div class="card-header">
              <span>统计概览</span>
            </div>
          </template>
          <div class="stats-grid">
            <div class="stats-item">
              <div class="stats-label">充值总金额</div>
              <div class="stats-value">{{ formatMoneyValue(statisticsData.totalAmount) }}</div>
            </div>
            <div class="stats-item">
              <div class="stats-label">总收入</div>
              <div class="stats-value">{{ formatMoneyValue(statisticsData.totalIncome) }}</div>
            </div>
            <div class="stats-item">
              <div class="stats-label">活动金额</div>
              <div class="stats-value">{{ formatMoneyValue(statisticsData.totalActivityAmount) }}</div>
            </div>
            <div class="stats-item">
              <div class="stats-label">充值笔数</div>
              <div class="stats-value">{{ statisticsData.totalCount || 0 }}</div>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 加气员统计 -->
      <div class="attendant-stats" style="margin-top: 20px;">
        <el-card shadow="hover" class="stats-card">
          <template #header>
            <div class="card-header">
              <span>加气员统计</span>
            </div>
          </template>
          <div style="margin-bottom: 20px;">
            <div ref="attendantChart" style="width: 100%; height: 400px;"></div>
          </div>
          <el-table :data="attendantStats" style="width: 100%">
            <el-table-column prop="attendantId" label="加气员ID" width="120" align="center" />
            <el-table-column label="加气员姓名" width="180" align="center">
              <template #default="scope">
                {{ getAttendantName(scope.row.attendantId) }}
              </template>
            </el-table-column>
            <el-table-column label="充值笔数" width="120" align="center">
              <template #default="scope">
                {{ scope.row.count || 0 }}
              </template>
            </el-table-column>
            <el-table-column label="充值总金额" width="180" align="center">
              <template #default="scope">
                {{ formatMoneyValue(scope.row.amount * 100) }}
              </template>
            </el-table-column>
            <el-table-column label="实际收入" width="180" align="center">
              <template #default="scope">
                {{ formatMoneyValue(scope.row.income * 100) }}
              </template>
            </el-table-column>
            <el-table-column label="活动金额" align="center">
              <template #default="scope">
                {{ formatMoneyValue(scope.row.activityAmount * 100) }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>

      <!-- 充值明细 -->
      <div class="recharge-detail" style="margin-top: 20px;">
        <el-card shadow="hover" class="stats-card">
          <template #header>
            <div class="card-header">
              <span>充值明细</span>
            </div>
          </template>
          <el-table :data="rechargeDetails" style="width: 100%">
            <el-table-column prop="id" label="ID" width="80" />
            <el-table-column prop="name" label="用户姓名" width="120" />
            <el-table-column prop="phone" label="手机号" width="150" />
            <el-table-column label="充值金额" width="120">
              <template #default="scope">
                {{ formatMoneyValue(scope.row.amount * 100) }}
              </template>
            </el-table-column>
            <el-table-column label="实际支付" width="120">
              <template #default="scope">
                {{ formatMoneyValue(scope.row.actual_amount * 100) }}
              </template>
            </el-table-column>
            <el-table-column label="活动赠送" width="120">
              <template #default="scope">
                {{ formatMoneyValue(scope.row.activity_amount * 100) }}
              </template>
            </el-table-column>
            <el-table-column prop="yuser_id" label="加气员ID" width="100" />
            <el-table-column label="加气员姓名" width="120">
              <template #default="scope">
                {{ getAttendantName(scope.row.yuser_id) }}
              </template>
            </el-table-column>
            <el-table-column label="充值时间" width="180">
              <template #default="scope">
                {{ formatDateTimeValue(scope.row.created_at) }}
              </template>
            </el-table-column>
            <el-table-column prop="note" label="备注" />
          </el-table>
          <el-pagination
            v-if="total > 0"
            style="margin-top: 20px; text-align: right;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </el-card>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "../../../components/container/Container";
import * as echarts from 'echarts';

export default {
  components: { Container },
  data() {
    return {
      selectedDate: '',
      statisticsData: { totalAmount: 0, totalIncome: 0, totalActivityAmount: 0, totalCount: 0 },
      attendantStats: [],
      rechargeDetails: [],
      total: 0,
      page: 1,
      pageSize: 10,
      userList: [],
      attendantChart: null,
    };
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeAttendantChart);
    if (this.attendantChart) {
      this.attendantChart.dispose();
      this.attendantChart = null;
    }
  },
  mounted() {
    this.selectedDate = new Date().toISOString().split('T')[0];
    this.getUserList();
    this.searchData();
  },
  methods: {
    async getUserList() {
      try {
        const response = await this.$api.feng.getdata('yuser', {});
        if (response.success) this.userList = response.data || [];
      } catch (error) { console.error('获取用户列表失败:', error); }
    },
    async searchData() {
      try {
        const date = this.selectedDate || new Date().toISOString().split('T')[0];
        const startTime = new Date(date).getTime();
        const endTime = startTime + 24 * 60 * 60 * 1000 - 1;
        const statsResponse = await this.$api.feng.getRechargeStatistics({ startTime, endTime });
        if (statsResponse.success) {
          this.statisticsData = {
            totalAmount: parseFloat(statsResponse.data.totalAmount) || 0,
            totalIncome: parseFloat(statsResponse.data.totalIncome) || 0,
            totalActivityAmount: parseFloat(statsResponse.data.totalActivityAmount) || 0,
            totalCount: statsResponse.data.details ? statsResponse.data.details.length : 0,
          };
          this.attendantStats = statsResponse.data.attendantStats || [];
          this.rechargeDetails = statsResponse.data.details || [];
          this.total = statsResponse.data.details ? statsResponse.data.details.length : 0;
          this.renderAttendantChart();
        }
      } catch (error) {
        console.error('获取充值统计数据失败:', error);
        this.$message.error('获取数据失败');
      }
    },
    renderAttendantChart() {
      if (!this.$refs.attendantChart) return;
      if (!this.attendantChart) {
        this.attendantChart = echarts.init(this.$refs.attendantChart);
        window.addEventListener('resize', this.resizeAttendantChart);
      }
      const attendantNames = this.attendantStats.map(item => this.getAttendantName(item.attendantId));
      const amounts = this.attendantStats.map(item => Number(item.amount || 0));

      this.attendantChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: (params) => params[0].name + '<br/>充值总金额: ¥' + Number(params[0].value).toFixed(2),
        },
        grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
        xAxis: { type: 'category', data: attendantNames, axisLabel: { interval: 0, rotate: 30 } },
        yAxis: { type: 'value', name: '金额 (元)', axisLabel: { formatter: '¥{value}' } },
        series: [{
          name: '充值总金额',
          type: 'bar',
          data: amounts,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#83bff6' },
              { offset: 0.5, color: '#188df0' },
              { offset: 1, color: '#188df0' },
            ]),
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#2378f7' },
                { offset: 0.7, color: '#2378f7' },
                { offset: 1, color: '#83bff6' },
              ]),
            },
          },
          label: { show: true, position: 'top', formatter: '¥{c}' },
        }],
      });
    },
    resizeAttendantChart() { this.attendantChart?.resize(); },
    async exportExcel() { /* 保留原逻辑不变 */ },
    getAttendantName(attendantId) {
      if (Number(attendantId) === 0) return '系统加气';
      const user = this.userList.find(u => String(u.id) === String(attendantId));
      return user ? user.name : `加气员${attendantId}`;
    },
    formatMoneyValue(value) {
      if (value === null || value === undefined || isNaN(value)) return '¥0.00';
      return `¥${(parseFloat(value) / 100).toFixed(2)}`;
    },
    formatDateTimeValue(value) {
      if (!value) return '-';
      return new Date(value).toLocaleString('zh-CN');
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.searchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.searchData();
    },
  },
};
</script>

<style scoped>
.stats-overview {
  margin-bottom: 20px;
}

.stats-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 10px;
}

.stats-item {
  text-align: center;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 8px;
}

.stats-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
}

.stats-value {
  font-size: 24px;
  font-weight: bold;
  color: #409eff;
}

.recharge-detail {
  margin-bottom: 20px;
}
</style>